import unique from 'lodash-es/uniq';
import * as C from '../constants';
import xmlStatsService from '../../../services/xml-stats-service';

export default {
  /**
   * @param commit
   * @param payload
   */
  getXmlChannels({ commit }) {
    commit(C.XML_CHANNEL_STATUS_PENDING);
    return xmlStatsService.getXmlChannels()
      .then((res) => {
        if (res.status === 200) {
          const systems = [];
          res.data.forEach((channel) => {
            systems.push(channel.system);
          });
          commit(C.XML_CHANNEL_STATUS_SUCCESS, { channels: res.data, systems: unique(systems) });
        } else {
          commit(C.XML_CHANNEL_STATUS_NO_CONTENT);
        }
      })
      .catch(() => {
        commit(C.XML_CHANNEL_STATUS_FAILURE);
      });
  },

  /**
   * @param commit
   * @param searchWord
   */
  updateXmlChannelFilterSearch({ commit }, searchWord) {
    commit(C.XML_CHANNEL_FILTER_SEARCH, searchWord);
  },

  /**
   * @param commit
   * @param statusFilter
   */
  updateXmlChannelFilterStatus({ commit }, statusFilter) {
    commit(C.XML_CHANNEL_FILTER_STATUS, statusFilter);
  },

  /**
   * @param commit
   * @param systemFilter
   */
  updateXmlChannelFilterSystem({ commit }, systemFilter) {
    commit(C.XML_CHANNEL_FILTER_SYSTEM, systemFilter);
  },

  /**
   * @param commit
   * @param payload
   */
  getXmlJobs({ commit, state }) {
    const xmlChannel = state.xmlJobList.xmlChannel;
    if (!xmlChannel) {
      commit(C.XML_JOB_LIST_FAILURE);
      return;
    }

    commit(C.XML_JOB_LIST_PENDING);
    xmlStatsService.getXmlJobs(xmlChannel.id, xmlChannel.subChannelId)
      .then((res) => {
        if (res.status === 200) {
          commit(C.XML_JOB_LIST_SUCCESS, res.data);
        } else {
          commit(C.XML_JOB_LIST_NO_CONTENT);
        }
      })
      .catch(() => {
        commit(C.XML_JOB_LIST_FAILURE);
      });
  },

  /**
   * @param commit
   * @param payload
   */
  getXmlJobsOverview({ commit }) {
    commit(C.XML_JOBS_OVERVIEW_PENDING);
    return xmlStatsService.getXmlJobsOverview()
      .then((res) => {
        if (res.status === 200) {
          commit(C.XML_JOBS_OVERVIEW_SUCCESS, res.data);
        } else {
          commit(C.XML_JOBS_OVERVIEW_NO_CONTENT);
        }
      })
      .catch(() => {
        commit(C.XML_JOBS_OVERVIEW_FAILURE);
      });
  },

  /**
   * @param commit
   * @param dispatch
   * @param state
   * @param xmlChannel
   */
  openJobList({ commit, dispatch, state }, xmlChannel) {
    if (!state.xmlJobList.xmlChannel || state.xmlJobList.xmlChannel !== xmlChannel) {
      commit(C.XML_JOB_LIST_SET_XML_CHANNEL, xmlChannel);
      dispatch('getXmlJobs');
    }
  },

  /**
   * @param commit
   * @param dispatch
   * @param state
   * @param xmlChannel
   */
  activateLatestJob({ commit, dispatch }, xmlChannel) {
    commit(C.XML_JOB_ACTIVATE_PENDING);
    return xmlStatsService.activateLatestJob(xmlChannel.webservice, xmlChannel.subChannelName)
      .then(() => {
        commit(C.XML_JOB_ACTIVATE_SUCCESS);
        dispatch('getXmlChannels');
      })
      .catch(() => {
        commit(C.XML_JOB_ACTIVATE_FAILURE);
      });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/xmlChannelStatus/actions.js